import { http } from "@next-core/http";
/**
 * @description 查询活动记录列表
 * @endpoint GET /api/v1/elevo/spaces/:spaceId/activities
 */
export const ElevoSpaceApi_listActivityLogs = async (spaceId, params, options) => /**! @contract easyops.api.llm.elevo_space.ListActivityLogs@1.0.0 */(await http.get(`api/gateway/logic.llm.aiops_service/api/v1/elevo/spaces/${spaceId}/activities`, {
  ...options,
  params
})).data;
//# sourceMappingURL=listActivityLogs.js.map